// ... Otras importaciones
import React, { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Collapse,
  IconButton,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

// Import your chart components
import DistribucionIndustriaPie from './Charts/DistribucionIndustriaPie';
import DistribucionEmpleadosHorizontalBar from './Charts/DistribucionEmpleadosHorizontalBar';
import DistribucionFacturacionLine from './Charts/DistribucionFacturacionLine';
import FillRateBar from './Charts/FillRateBar';
import OrdenVentaPerfectaArea from './Charts/OrdenVentaPerfectaArea';
import OrdendeVentaPerfectaDoughnut from './Charts/OrdendeVentaPerfectaDoughnut';
import RotacionPersonalBar from './Charts/RotacionPersonalBar';
import FillRateVsEntregasBar from './Charts/FillRateVsEntregasBar';
import DiasPromedioEntregaBar from './Charts/DiasPromedioEntregaBar';
import RotacionInventarioBar from './Charts/RotacionInventarioBar';
import UtilizacionAlmacenRadar from './Charts/UtilizacionAlmacenRadar';
import TransporteTercerizadoUtilizacionBar from './Charts/TransporteTercerizadoUtilizacionBar';
import EntregasATiempoBar from './Charts/EntregasATiempoBar';
import CostoTransporteVentasBar from './Charts/CostoTransporteVentasBar';
import CostoDistribucionVentasBar from './Charts/CostoDistribucionVentasBar';
import CostoLogisticoVentasBar from './Charts/CostoLogisticoVentasBar';
import CostosAgrupadosBar from './Charts/CostosAgrupadosBar';
import Ibso from "../src/Ibso.png";
import InfoBoxes from './Charts/InfoBoxes';
import CostTable from './Charts/CostTable';
import TercerizacionAlmacen from './Charts/TercerizacionAlmacen';
import HuellaPie from './Charts/MedicionHuella'
import HuellaFacturacion from './Charts/HuellaFacturacion';
import TonsCarbono from './Charts/TonsCarbono';
import CostoNomina from './Charts/CostoNomina';
import UtilizacionContenedoresTransporte from './Charts/nueva';
import TablaLogistica from './Charts/tabla'

// Import react-icons para el botón de WhatsApp
import { FaWhatsapp } from 'react-icons/fa';
import RotacionPersonal from './Charts/RotacionPersonal';





const Root = styled('div')({
  display: 'flex',
  minHeight: '100vh',
  background: 'linear-gradient(to right, #b3cde0, #1f78b4)',
});

const Sidebar = styled(Drawer)({
  width: 240,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: 240,
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    paddingTop: '0px',
  },
});

const LogoBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: '10px',
  paddingBottom: '8px',
  marginBottom: '4px',
  borderBottom: '1px solid #d0d0d0',
});

const HeaderSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  color: '#fff',
  background: '#1F3D58',
  textAlign: 'center',
}));

const SectionWrapper = styled(Card)(({ theme }) => ({
  backgroundColor: '#ffffff',
  marginBottom: theme.spacing(2),
  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: 'bold',
  color: '#fff',
  padding: theme.spacing(1),
  backgroundColor: '#3c3c3c',
  textAlign: 'center',
  borderRadius: '4px 4px 0 0',
}));

const Content = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: '20px 10px 20px 10px',
}));

const WhatsappButton = () => {
  const [showPopup, setShowPopup] = useState(true);
  const whatsappLink =
    "https://api.whatsapp.com/send?phone=5215525000290&text=Hola%20quisiera%20más%20información%20sobre%20su%20diagnóstico%20gratuito.";

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
      }}
    >
      {showPopup && (
        <div
          style={{
            marginBottom: '10px',
            backgroundColor: '#fff',
            padding: '10px 15px',
            borderRadius: '8px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
            display: 'flex',
            alignItems: 'center',
            maxWidth: '250px',
          }}
        >
          <span style={{ flex: 1, fontSize: '0.9rem', color: '#333' }}>
            Agenda tu diagnóstico gratuito para explorar cómo podemos ayudarte a tomar decisiones a través de los datos.
          </span>
          <button
            onClick={() => setShowPopup(false)}
            style={{
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              fontSize: '1rem',
              lineHeight: '1',
              color: '#333',
              marginLeft: '8px',
            }}
            aria-label="Cerrar popup"
          >
            x
          </button>
        </div>
      )}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          backgroundColor: '#fff',
          borderRadius: '50%',
          padding: '10px',
          width: '50px',
          height: '50px',
          boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <FaWhatsapp size={32} color="#25D366" />
      </a>
    </div>
  );
};

function App() {
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [employeePercentageData, setEmployeePercentageData] = useState([]);
  const [openMainSections, setOpenMainSections] = useState({});
  const [selectedCharts, setSelectedCharts] = useState([]);

  const sections = {
    'Datos generales':{
      subsections: [
        { title: 'Distribución por industria', component: DistribucionIndustriaPie },
        { title: 'Distribución por número de empleados', component: DistribucionEmpleadosHorizontalBar },
        { title: 'Distribución por facturación anual', component: DistribucionFacturacionLine },
      ],
    },
    'Sección I. Indicadores de nivel de servicio y logística de entrega al cliente.': {
      subsections: [
        { title: 'Fill rate de entrega a cliente', component: FillRateBar },
        { title: 'Orden de venta perfecta ', component: OrdendeVentaPerfectaDoughnut },
        { title: 'Orden de venta perfecta por número de empleados', component: OrdenVentaPerfectaArea },
        { title: 'Precisión del  pronóstico', component: RotacionPersonalBar },
      ],
    },
    'Sección II. Indicadores de abastecimiento.': {
      subsections: [
        { title: 'Fill rate de compras', component: FillRateVsEntregasBar },
        { title: 'Entregas a tiempo de proveedor', component: DiasPromedioEntregaBar },
       // { title: 'Días de entrega de proveedor por facturación anual', component: DiasEntregaPorFacturacionBar },
        { title: 'Rotación anual de inventario', component: RotacionInventarioBar },
        { title: 'Utilización de almacén', component: UtilizacionAlmacenRadar },
        { title: 'Tercerización de almacenes', component: TercerizacionAlmacen },
      ],
    },
    'Sección III. Indicadores de transporte.': {
      subsections: [
        { title: 'Transporte tercerizado', component: TransporteTercerizadoUtilizacionBar },
        { title: 'Utilización de contenedores/camiones de carga', component: UtilizacionContenedoresTransporte },
        { title: 'Entregas a tiempo del transporte al cliente', component: EntregasATiempoBar },
        { title: 'Rotación de personal logístico', component: RotacionPersonal },
        { title: 'Medición de huella de carbono (logística)', component: HuellaPie },
        { title: 'Medición de huella de carbono por nivel de facturación', component: HuellaFacturacion },
        { title: 'Huella de carbono (TON CO2) por industria', component: TonsCarbono },
      ],  
    },
    'Sección IV. Indicadores financieros.': {
      subsections: [
        { title: 'Costo de nómina logística', component: CostoNomina },
        { title: 'Costo de transporte como % de las ventas totales', component: CostoTransporteVentasBar },
        { title: 'Costo de distribución como % de las ventas totales', component: CostoDistribucionVentasBar },
        //{ title: 'Costo logístico total como % de las ventas totales', component: CostoLogisticoVentasBar },
        { title: 'Costo de transporte, costo de distribución y costo total de servir como % de las ventas totales', component: CostosAgrupadosBar, TablaLogistica},
        { title: 'Tabla | Costo de transporte, costo de distribución y costo total de servir como % de las ventas totales' ,component: TablaLogistica },
        
      ],
    },
  };

  const handleMainSectionClick = (section) => {
    setOpenMainSections((prevOpenSections) => ({
      ...prevOpenSections,
      [section]: !prevOpenSections[section],
    }));
  };

  const handleAddChart = (subSectionTitle) => {
    setSelectedCharts((prevSelectedCharts) => {
      if (!prevSelectedCharts.includes(subSectionTitle)) {
        return [...prevSelectedCharts, subSectionTitle];
      } else {
        return prevSelectedCharts.filter(title => title !== subSectionTitle);
      }
    });
  };

  const employeeRangeByIndustry = {
    Alimentos: [0, 1, 4, 3, 6, 11],
    Retail: [1, 1, 0, 2, 4, 12],
    Logística: [1, 2, 0, 1, 2, 0],
    Manufactura: [0, 0, 0, 0, 1, 1],
    Automotriz: [0, 0, 1, 0, 3, 7],
    'Salud/Farmacéutica': [0, 1, 1, 3, 1, 4],
    Construcción: [0, 2, 2, 0, 1, 1],
  };

  const handleIndustrySelection = (industries) => {
    setSelectedIndustries(industries);
    if (industries.length > 0) {
      const combinedData = calculateCombinedEmployeeData(industries);
      setEmployeePercentageData(combinedData);
    } else {
      const allIndustries = Object.keys(employeeRangeByIndustry);
      setEmployeePercentageData(calculateCombinedEmployeeData(allIndustries));
    }
  };

  const calculateCombinedEmployeeData = (industries) => {
    const summedEmployeeData = industries.reduce((acc, industry) => {
      const industryData = employeeRangeByIndustry[industry] || [];
      return acc.map((value, index) => value + (industryData[index] || 0));
    }, Array(6).fill(0));

    const total = summedEmployeeData.reduce((sum, value) => sum + value, 0);
    return summedEmployeeData.map((value) => ((value / total) * 100).toFixed(2));
  };

  useEffect(() => {
    const initialIndustries = Object.keys(employeeRangeByIndustry);
    setEmployeePercentageData(calculateCombinedEmployeeData(initialIndustries));
  }, []);

  const getSubSectionByTitle = (title) => {
    for (const mainSection of Object.values(sections)) {
      for (const subSection of mainSection.subsections) {
        if (subSection.title === title) {
          return subSection;
        }
      }
    }
    return null;
  };

  return (
    <Root>
      <Sidebar variant="permanent" anchor="left">
        <LogoBox>
          <a href="https://ibso.mx" target="_blank" rel="noopener noreferrer">
            <img src={Ibso} alt="IBSO Logo" style={{ width: '100px' }} />
          </a>
        </LogoBox>

        <List>
          {Object.keys(sections).map((mainSection) => (
            <React.Fragment key={mainSection}>
              <ListItem button onClick={() => handleMainSectionClick(mainSection)}>
                <ListItemText primary={mainSection} />
                {openMainSections[mainSection] ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={openMainSections[mainSection]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {sections[mainSection].subsections.map((subSection) => {
                    const isSelected = selectedCharts.includes(subSection.title);
                    return (
                      <ListItem key={subSection.title} sx={{ pl: 4 }}>
                        <ListItemText primary={<Typography>{subSection.title}</Typography>} />
                        <IconButton onClick={() => handleAddChart(subSection.title)}>
                          {isSelected ? <RemoveIcon /> : <AddIcon />}
                        </IconButton>
                      </ListItem>
                    );
                  })}
                </List>
              </Collapse>
            </React.Fragment>
          ))}
        </List>
      </Sidebar>

      <Content>
        <HeaderSection>
          <Typography variant="h3" gutterBottom>
            Dashboard de Indicadores Logísticos
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            El estudio fue realizado con datos del año 2022 - 2023
          </Typography>
        </HeaderSection>
        <InfoBoxes />

        <Container maxWidth={false}>
          <Grid container spacing={1}>
            {selectedCharts.map((title) => {
              const sub = getSubSectionByTitle(title);
              if (!sub) return null;

              if (title === 'Tabla de Costos') {
                return (
                  <Grid item xs={12} key={sub.title}>
                    <SectionWrapper style={{ width: '100%', maxWidth: '100%' }}>
                      <SectionTitle>{sub.title}</SectionTitle>
                      <CardContent>
                        <sub.component
                          selectedIndustries={selectedIndustries}
                          onBarClick={handleIndustrySelection}
                          data={employeeRangeByIndustry}
                          employeeData={employeePercentageData}
                        />
                      </CardContent>
                    </SectionWrapper>
                  </Grid>
                );
              }

              return (
                <Grid item xs={12} md={6} key={sub.title}>
                  <SectionWrapper>
                    <SectionTitle>{sub.title}</SectionTitle>
                    <CardContent>
                      <sub.component
                        selectedIndustries={selectedIndustries}
                        onBarClick={handleIndustrySelection}
                        data={employeeRangeByIndustry}
                        employeeData={employeePercentageData}
                      />
                    </CardContent>
                  </SectionWrapper>
                </Grid>
              );
            })}
          </Grid>
        </Container>
      </Content>

      <WhatsappButton />
    </Root>
  );
}


export default App;